import {LOGIN} from '../../constants/LoginConstants';
import {GeneralAction, LoginPayload} from '../../@types/actions';

export const LoginAction = (data: LoginPayload): GeneralAction<LoginPayload> => ({type: LOGIN, payload: data});
